import { default as _91_46_46_46slug_93XOh4cis8EcMeta } from "/app/src/pages/[...slug].vue?macro=true";
import { default as indexPlSNFFmiLMMeta } from "/app/src/pages/admission/campaign/faculties/index.vue?macro=true";
import { default as indexmp7aVBzQboMeta } from "/app/src/pages/admission/campaign/faculties/specialities/index.vue?macro=true";
import { default as index6h62cjui4lMeta } from "/app/src/pages/admission/campaign/faculties/specialities/rating/index.vue?macro=true";
import { default as index88NEIirHQlMeta } from "/app/src/pages/admission/campaign/index.vue?macro=true";
import { default as indexRGgAbWSDzqMeta } from "/app/src/pages/admission/campaign/rating/index.vue?macro=true";
import { default as indexcv2a93Fgb8Meta } from "/app/src/pages/admission/campaign/specialities/index.vue?macro=true";
import { default as indexIwbpY5PIK5Meta } from "/app/src/pages/auth/index.vue?macro=true";
import { default as indexuBoybSaeFZMeta } from "/app/src/pages/calc/index.vue?macro=true";
import { default as indexiuRxfXQmyoMeta } from "/app/src/pages/calendar/schedule/index.vue?macro=true";
import { default as indexzAMwkzbgTbMeta } from "/app/src/pages/educational_programs/index.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as FormSelectKj0dOm8Aj9Meta } from "/app/src/pages/programs/FormSelect.vue?macro=true";
import { default as index4lPQjCfUMvMeta } from "/app/src/pages/programs/index.vue?macro=true";
import { default as indextDRAj3hOgpMeta } from "/app/src/pages/schedule/index.vue?macro=true";
import { default as indexkS991j4acnMeta } from "/app/src/pages/user/admin/achievements/index.vue?macro=true";
import { default as indexEplsi8ZJXVMeta } from "/app/src/pages/user/admin/admission_campaign/group/index.vue?macro=true";
import { default as indexsP5fswWKC6Meta } from "/app/src/pages/user/admin/admission_campaign/index.vue?macro=true";
import { default as index4py1DPE33aMeta } from "/app/src/pages/user/admin/announcement/index.vue?macro=true";
import { default as indexlynqxQcrVlMeta } from "/app/src/pages/user/admin/schedule/index.vue?macro=true";
import { default as indexW8H5e3Y9aAMeta } from "/app/src/pages/user/admin/sessions/index.vue?macro=true";
import { default as indexCtFJWvn2laMeta } from "/app/src/pages/user/chats/index.vue?macro=true";
import { default as indexAXkeIboLlqMeta } from "/app/src/pages/user/index.vue?macro=true";
import { default as indexlJxs2MWaJYMeta } from "/app/src/pages/user/recovery/confirm/index.vue?macro=true";
import { default as indexaGiT3ZMBl7Meta } from "/app/src/pages/user/register/confirm/index.vue?macro=true";
import { default as indexiOw8bizPzdMeta } from "/app/src/pages/user/register/index.vue?macro=true";
import { default as indexKW8XLdCrAHMeta } from "/app/src/pages/user/sessions/index.vue?macro=true";
import { default as index4PAjFAZIytMeta } from "/app/src/pages/user/staff/bypass_type/index.vue?macro=true";
import { default as indexiCLegs3jOAMeta } from "/app/src/pages/user/staff/bypasses/index.vue?macro=true";
import { default as indexq8cWSv96ybMeta } from "/app/src/pages/user/staff/diplom/index.vue?macro=true";
import { default as indexXTk7AkeiGlMeta } from "/app/src/pages/user/staff/educational_programs/index.vue?macro=true";
import { default as indexV5JLiH7GUEMeta } from "/app/src/pages/user/staff/index.vue?macro=true";
import { default as indexKAobrnhJDnMeta } from "/app/src/pages/user/staff/persons/index.vue?macro=true";
import { default as indexbRba0ge7U1Meta } from "/app/src/pages/user/staff/portfolio_type/index.vue?macro=true";
import { default as indexU7ZmYna7ndMeta } from "/app/src/pages/user/staff/reference_type/index.vue?macro=true";
import { default as indexcpQlBBeuuBMeta } from "/app/src/pages/user/staff/references/index.vue?macro=true";
import { default as indexE4CJ2Im0ZPMeta } from "/app/src/pages/user/staff/user_groups/index.vue?macro=true";
import { default as indexzdbY1daZKOMeta } from "/app/src/pages/user/student/academic_plan/index.vue?macro=true";
import { default as indexdd9VitakNPMeta } from "/app/src/pages/user/student/bypasses/index.vue?macro=true";
import { default as indexPQ6F1o2LG2Meta } from "/app/src/pages/user/student/calendar_schedule/index.vue?macro=true";
import { default as indexa2alXNdyifMeta } from "/app/src/pages/user/student/orders/index.vue?macro=true";
import { default as indexOpt357Y7qQMeta } from "/app/src/pages/user/student/performance/index.vue?macro=true";
import { default as index11eXTPp0aCMeta } from "/app/src/pages/user/student/portfolio/index.vue?macro=true";
import { default as index1oSaBluaRoMeta } from "/app/src/pages/user/student/progress/index.vue?macro=true";
import { default as indexgdXmrMLLA7Meta } from "/app/src/pages/user/student/references/index.vue?macro=true";
import { default as indexdBTSfFzG9jMeta } from "/app/src/pages/user/student/theme/index.vue?macro=true";
import { default as indexsKVfReJQVcMeta } from "/app/src/pages/user/teacher/calendar_schedule/index.vue?macro=true";
import { default as indexr3ThPHUZuZMeta } from "/app/src/pages/user/teacher/index.vue?macro=true";
import { default as indexpvaEHvSxumMeta } from "/app/src/pages/user/teacher/performance/index.vue?macro=true";
import { default as indexp4KlwVwfckMeta } from "/app/src/pages/user/teacher/portfolio/index.vue?macro=true";
import { default as indexEvdQjf4XMhMeta } from "/app/src/pages/user/teacher/schedule_create/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46slug_93XOh4cis8EcMeta?.name ?? "slug",
    path: _91_46_46_46slug_93XOh4cis8EcMeta?.path ?? "/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    alias: _91_46_46_46slug_93XOh4cis8EcMeta?.alias || [],
    redirect: _91_46_46_46slug_93XOh4cis8EcMeta?.redirect || undefined,
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexPlSNFFmiLMMeta?.name ?? "admission-campaign-faculties",
    path: indexPlSNFFmiLMMeta?.path ?? "/admission/campaign/faculties",
    meta: indexPlSNFFmiLMMeta || {},
    alias: indexPlSNFFmiLMMeta?.alias || [],
    redirect: indexPlSNFFmiLMMeta?.redirect || undefined,
    component: () => import("/app/src/pages/admission/campaign/faculties/index.vue").then(m => m.default || m)
  },
  {
    name: indexmp7aVBzQboMeta?.name ?? "admission-campaign-faculties-specialities",
    path: indexmp7aVBzQboMeta?.path ?? "/admission/campaign/faculties/specialities",
    meta: indexmp7aVBzQboMeta || {},
    alias: indexmp7aVBzQboMeta?.alias || [],
    redirect: indexmp7aVBzQboMeta?.redirect || undefined,
    component: () => import("/app/src/pages/admission/campaign/faculties/specialities/index.vue").then(m => m.default || m)
  },
  {
    name: index6h62cjui4lMeta?.name ?? "admission-campaign-faculties-specialities-rating",
    path: index6h62cjui4lMeta?.path ?? "/admission/campaign/faculties/specialities/rating",
    meta: index6h62cjui4lMeta || {},
    alias: index6h62cjui4lMeta?.alias || [],
    redirect: index6h62cjui4lMeta?.redirect || undefined,
    component: () => import("/app/src/pages/admission/campaign/faculties/specialities/rating/index.vue").then(m => m.default || m)
  },
  {
    name: index88NEIirHQlMeta?.name ?? "admission-campaign",
    path: index88NEIirHQlMeta?.path ?? "/admission/campaign",
    meta: index88NEIirHQlMeta || {},
    alias: index88NEIirHQlMeta?.alias || [],
    redirect: index88NEIirHQlMeta?.redirect || undefined,
    component: () => import("/app/src/pages/admission/campaign/index.vue").then(m => m.default || m)
  },
  {
    name: indexRGgAbWSDzqMeta?.name ?? "admission-campaign-rating",
    path: indexRGgAbWSDzqMeta?.path ?? "/admission/campaign/rating",
    meta: indexRGgAbWSDzqMeta || {},
    alias: indexRGgAbWSDzqMeta?.alias || [],
    redirect: indexRGgAbWSDzqMeta?.redirect || undefined,
    component: () => import("/app/src/pages/admission/campaign/rating/index.vue").then(m => m.default || m)
  },
  {
    name: indexcv2a93Fgb8Meta?.name ?? "admission-campaign-specialities",
    path: indexcv2a93Fgb8Meta?.path ?? "/admission/campaign/specialities",
    meta: indexcv2a93Fgb8Meta || {},
    alias: indexcv2a93Fgb8Meta?.alias || [],
    redirect: indexcv2a93Fgb8Meta?.redirect || undefined,
    component: () => import("/app/src/pages/admission/campaign/specialities/index.vue").then(m => m.default || m)
  },
  {
    name: indexIwbpY5PIK5Meta?.name ?? "auth",
    path: indexIwbpY5PIK5Meta?.path ?? "/auth",
    meta: indexIwbpY5PIK5Meta || {},
    alias: indexIwbpY5PIK5Meta?.alias || [],
    redirect: indexIwbpY5PIK5Meta?.redirect || undefined,
    component: () => import("/app/src/pages/auth/index.vue").then(m => m.default || m)
  },
  {
    name: indexuBoybSaeFZMeta?.name ?? "calc",
    path: indexuBoybSaeFZMeta?.path ?? "/calc",
    meta: indexuBoybSaeFZMeta || {},
    alias: indexuBoybSaeFZMeta?.alias || [],
    redirect: indexuBoybSaeFZMeta?.redirect || undefined,
    component: () => import("/app/src/pages/calc/index.vue").then(m => m.default || m)
  },
  {
    name: indexiuRxfXQmyoMeta?.name ?? "calendar-schedule",
    path: indexiuRxfXQmyoMeta?.path ?? "/calendar/schedule",
    meta: indexiuRxfXQmyoMeta || {},
    alias: indexiuRxfXQmyoMeta?.alias || [],
    redirect: indexiuRxfXQmyoMeta?.redirect || undefined,
    component: () => import("/app/src/pages/calendar/schedule/index.vue").then(m => m.default || m)
  },
  {
    name: indexzAMwkzbgTbMeta?.name ?? "educational_programs",
    path: indexzAMwkzbgTbMeta?.path ?? "/educational_programs",
    meta: indexzAMwkzbgTbMeta || {},
    alias: indexzAMwkzbgTbMeta?.alias || [],
    redirect: indexzAMwkzbgTbMeta?.redirect || undefined,
    component: () => import("/app/src/pages/educational_programs/index.vue").then(m => m.default || m)
  },
  {
    name: indexdPwi6hPdMfMeta?.name ?? "index",
    path: indexdPwi6hPdMfMeta?.path ?? "/",
    meta: indexdPwi6hPdMfMeta || {},
    alias: indexdPwi6hPdMfMeta?.alias || [],
    redirect: indexdPwi6hPdMfMeta?.redirect || undefined,
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: FormSelectKj0dOm8Aj9Meta?.name ?? "programs-FormSelect",
    path: FormSelectKj0dOm8Aj9Meta?.path ?? "/programs/FormSelect",
    meta: FormSelectKj0dOm8Aj9Meta || {},
    alias: FormSelectKj0dOm8Aj9Meta?.alias || [],
    redirect: FormSelectKj0dOm8Aj9Meta?.redirect || undefined,
    component: () => import("/app/src/pages/programs/FormSelect.vue").then(m => m.default || m)
  },
  {
    name: index4lPQjCfUMvMeta?.name ?? "programs",
    path: index4lPQjCfUMvMeta?.path ?? "/programs",
    meta: index4lPQjCfUMvMeta || {},
    alias: index4lPQjCfUMvMeta?.alias || [],
    redirect: index4lPQjCfUMvMeta?.redirect || undefined,
    component: () => import("/app/src/pages/programs/index.vue").then(m => m.default || m)
  },
  {
    name: indextDRAj3hOgpMeta?.name ?? "schedule",
    path: indextDRAj3hOgpMeta?.path ?? "/schedule",
    meta: indextDRAj3hOgpMeta || {},
    alias: indextDRAj3hOgpMeta?.alias || [],
    redirect: indextDRAj3hOgpMeta?.redirect || undefined,
    component: () => import("/app/src/pages/schedule/index.vue").then(m => m.default || m)
  },
  {
    name: indexkS991j4acnMeta?.name ?? "user-admin-achievements",
    path: indexkS991j4acnMeta?.path ?? "/user/admin/achievements",
    meta: indexkS991j4acnMeta || {},
    alias: indexkS991j4acnMeta?.alias || [],
    redirect: indexkS991j4acnMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/admin/achievements/index.vue").then(m => m.default || m)
  },
  {
    name: indexEplsi8ZJXVMeta?.name ?? "user-admin-admission_campaign-group",
    path: indexEplsi8ZJXVMeta?.path ?? "/user/admin/admission_campaign/group",
    meta: indexEplsi8ZJXVMeta || {},
    alias: indexEplsi8ZJXVMeta?.alias || [],
    redirect: indexEplsi8ZJXVMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/admin/admission_campaign/group/index.vue").then(m => m.default || m)
  },
  {
    name: indexsP5fswWKC6Meta?.name ?? "user-admin-admission_campaign",
    path: indexsP5fswWKC6Meta?.path ?? "/user/admin/admission_campaign",
    meta: indexsP5fswWKC6Meta || {},
    alias: indexsP5fswWKC6Meta?.alias || [],
    redirect: indexsP5fswWKC6Meta?.redirect || undefined,
    component: () => import("/app/src/pages/user/admin/admission_campaign/index.vue").then(m => m.default || m)
  },
  {
    name: index4py1DPE33aMeta?.name ?? "user-admin-announcement",
    path: index4py1DPE33aMeta?.path ?? "/user/admin/announcement",
    meta: index4py1DPE33aMeta || {},
    alias: index4py1DPE33aMeta?.alias || [],
    redirect: index4py1DPE33aMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/admin/announcement/index.vue").then(m => m.default || m)
  },
  {
    name: indexlynqxQcrVlMeta?.name ?? "user-admin-schedule",
    path: indexlynqxQcrVlMeta?.path ?? "/user/admin/schedule",
    meta: indexlynqxQcrVlMeta || {},
    alias: indexlynqxQcrVlMeta?.alias || [],
    redirect: indexlynqxQcrVlMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/admin/schedule/index.vue").then(m => m.default || m)
  },
  {
    name: indexW8H5e3Y9aAMeta?.name ?? "user-admin-sessions",
    path: indexW8H5e3Y9aAMeta?.path ?? "/user/admin/sessions",
    meta: indexW8H5e3Y9aAMeta || {},
    alias: indexW8H5e3Y9aAMeta?.alias || [],
    redirect: indexW8H5e3Y9aAMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/admin/sessions/index.vue").then(m => m.default || m)
  },
  {
    name: indexCtFJWvn2laMeta?.name ?? "user-chats",
    path: indexCtFJWvn2laMeta?.path ?? "/user/chats",
    meta: indexCtFJWvn2laMeta || {},
    alias: indexCtFJWvn2laMeta?.alias || [],
    redirect: indexCtFJWvn2laMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/chats/index.vue").then(m => m.default || m)
  },
  {
    name: indexAXkeIboLlqMeta?.name ?? "user",
    path: indexAXkeIboLlqMeta?.path ?? "/user",
    meta: indexAXkeIboLlqMeta || {},
    alias: indexAXkeIboLlqMeta?.alias || [],
    redirect: indexAXkeIboLlqMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  },
  {
    name: indexlJxs2MWaJYMeta?.name ?? "user-recovery-confirm",
    path: indexlJxs2MWaJYMeta?.path ?? "/user/recovery/confirm",
    meta: indexlJxs2MWaJYMeta || {},
    alias: indexlJxs2MWaJYMeta?.alias || [],
    redirect: indexlJxs2MWaJYMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/recovery/confirm/index.vue").then(m => m.default || m)
  },
  {
    name: indexaGiT3ZMBl7Meta?.name ?? "user-register-confirm",
    path: indexaGiT3ZMBl7Meta?.path ?? "/user/register/confirm",
    meta: indexaGiT3ZMBl7Meta || {},
    alias: indexaGiT3ZMBl7Meta?.alias || [],
    redirect: indexaGiT3ZMBl7Meta?.redirect || undefined,
    component: () => import("/app/src/pages/user/register/confirm/index.vue").then(m => m.default || m)
  },
  {
    name: indexiOw8bizPzdMeta?.name ?? "user-register",
    path: indexiOw8bizPzdMeta?.path ?? "/user/register",
    meta: indexiOw8bizPzdMeta || {},
    alias: indexiOw8bizPzdMeta?.alias || [],
    redirect: indexiOw8bizPzdMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/register/index.vue").then(m => m.default || m)
  },
  {
    name: indexKW8XLdCrAHMeta?.name ?? "user-sessions",
    path: indexKW8XLdCrAHMeta?.path ?? "/user/sessions",
    meta: indexKW8XLdCrAHMeta || {},
    alias: indexKW8XLdCrAHMeta?.alias || [],
    redirect: indexKW8XLdCrAHMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/sessions/index.vue").then(m => m.default || m)
  },
  {
    name: index4PAjFAZIytMeta?.name ?? "user-staff-bypass_type",
    path: index4PAjFAZIytMeta?.path ?? "/user/staff/bypass_type",
    meta: index4PAjFAZIytMeta || {},
    alias: index4PAjFAZIytMeta?.alias || [],
    redirect: index4PAjFAZIytMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/bypass_type/index.vue").then(m => m.default || m)
  },
  {
    name: indexiCLegs3jOAMeta?.name ?? "user-staff-bypasses",
    path: indexiCLegs3jOAMeta?.path ?? "/user/staff/bypasses",
    meta: indexiCLegs3jOAMeta || {},
    alias: indexiCLegs3jOAMeta?.alias || [],
    redirect: indexiCLegs3jOAMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/bypasses/index.vue").then(m => m.default || m)
  },
  {
    name: indexq8cWSv96ybMeta?.name ?? "user-staff-diplom",
    path: indexq8cWSv96ybMeta?.path ?? "/user/staff/diplom",
    meta: indexq8cWSv96ybMeta || {},
    alias: indexq8cWSv96ybMeta?.alias || [],
    redirect: indexq8cWSv96ybMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/diplom/index.vue").then(m => m.default || m)
  },
  {
    name: indexXTk7AkeiGlMeta?.name ?? "user-staff-educational_programs",
    path: indexXTk7AkeiGlMeta?.path ?? "/user/staff/educational_programs",
    meta: indexXTk7AkeiGlMeta || {},
    alias: indexXTk7AkeiGlMeta?.alias || [],
    redirect: indexXTk7AkeiGlMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/educational_programs/index.vue").then(m => m.default || m)
  },
  {
    name: indexV5JLiH7GUEMeta?.name ?? "user-staff",
    path: indexV5JLiH7GUEMeta?.path ?? "/user/staff",
    meta: indexV5JLiH7GUEMeta || {},
    alias: indexV5JLiH7GUEMeta?.alias || [],
    redirect: indexV5JLiH7GUEMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/index.vue").then(m => m.default || m)
  },
  {
    name: indexKAobrnhJDnMeta?.name ?? "user-staff-persons",
    path: indexKAobrnhJDnMeta?.path ?? "/user/staff/persons",
    meta: indexKAobrnhJDnMeta || {},
    alias: indexKAobrnhJDnMeta?.alias || [],
    redirect: indexKAobrnhJDnMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/persons/index.vue").then(m => m.default || m)
  },
  {
    name: indexbRba0ge7U1Meta?.name ?? "user-staff-portfolio_type",
    path: indexbRba0ge7U1Meta?.path ?? "/user/staff/portfolio_type",
    meta: indexbRba0ge7U1Meta || {},
    alias: indexbRba0ge7U1Meta?.alias || [],
    redirect: indexbRba0ge7U1Meta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/portfolio_type/index.vue").then(m => m.default || m)
  },
  {
    name: indexU7ZmYna7ndMeta?.name ?? "user-staff-reference_type",
    path: indexU7ZmYna7ndMeta?.path ?? "/user/staff/reference_type",
    meta: indexU7ZmYna7ndMeta || {},
    alias: indexU7ZmYna7ndMeta?.alias || [],
    redirect: indexU7ZmYna7ndMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/reference_type/index.vue").then(m => m.default || m)
  },
  {
    name: indexcpQlBBeuuBMeta?.name ?? "user-staff-references",
    path: indexcpQlBBeuuBMeta?.path ?? "/user/staff/references",
    meta: indexcpQlBBeuuBMeta || {},
    alias: indexcpQlBBeuuBMeta?.alias || [],
    redirect: indexcpQlBBeuuBMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/references/index.vue").then(m => m.default || m)
  },
  {
    name: indexE4CJ2Im0ZPMeta?.name ?? "user-staff-user_groups",
    path: indexE4CJ2Im0ZPMeta?.path ?? "/user/staff/user_groups",
    meta: indexE4CJ2Im0ZPMeta || {},
    alias: indexE4CJ2Im0ZPMeta?.alias || [],
    redirect: indexE4CJ2Im0ZPMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/staff/user_groups/index.vue").then(m => m.default || m)
  },
  {
    name: indexzdbY1daZKOMeta?.name ?? "user-student-academic_plan",
    path: indexzdbY1daZKOMeta?.path ?? "/user/student/academic_plan",
    meta: indexzdbY1daZKOMeta || {},
    alias: indexzdbY1daZKOMeta?.alias || [],
    redirect: indexzdbY1daZKOMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/student/academic_plan/index.vue").then(m => m.default || m)
  },
  {
    name: indexdd9VitakNPMeta?.name ?? "user-student-bypasses",
    path: indexdd9VitakNPMeta?.path ?? "/user/student/bypasses",
    meta: indexdd9VitakNPMeta || {},
    alias: indexdd9VitakNPMeta?.alias || [],
    redirect: indexdd9VitakNPMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/student/bypasses/index.vue").then(m => m.default || m)
  },
  {
    name: indexPQ6F1o2LG2Meta?.name ?? "user-student-calendar_schedule",
    path: indexPQ6F1o2LG2Meta?.path ?? "/user/student/calendar_schedule",
    meta: indexPQ6F1o2LG2Meta || {},
    alias: indexPQ6F1o2LG2Meta?.alias || [],
    redirect: indexPQ6F1o2LG2Meta?.redirect || undefined,
    component: () => import("/app/src/pages/user/student/calendar_schedule/index.vue").then(m => m.default || m)
  },
  {
    name: indexa2alXNdyifMeta?.name ?? "user-student-orders",
    path: indexa2alXNdyifMeta?.path ?? "/user/student/orders",
    meta: indexa2alXNdyifMeta || {},
    alias: indexa2alXNdyifMeta?.alias || [],
    redirect: indexa2alXNdyifMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/student/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexOpt357Y7qQMeta?.name ?? "user-student-performance",
    path: indexOpt357Y7qQMeta?.path ?? "/user/student/performance",
    meta: indexOpt357Y7qQMeta || {},
    alias: indexOpt357Y7qQMeta?.alias || [],
    redirect: indexOpt357Y7qQMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/student/performance/index.vue").then(m => m.default || m)
  },
  {
    name: index11eXTPp0aCMeta?.name ?? "user-student-portfolio",
    path: index11eXTPp0aCMeta?.path ?? "/user/student/portfolio",
    meta: index11eXTPp0aCMeta || {},
    alias: index11eXTPp0aCMeta?.alias || [],
    redirect: index11eXTPp0aCMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/student/portfolio/index.vue").then(m => m.default || m)
  },
  {
    name: index1oSaBluaRoMeta?.name ?? "user-student-progress",
    path: index1oSaBluaRoMeta?.path ?? "/user/student/progress",
    meta: index1oSaBluaRoMeta || {},
    alias: index1oSaBluaRoMeta?.alias || [],
    redirect: index1oSaBluaRoMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/student/progress/index.vue").then(m => m.default || m)
  },
  {
    name: indexgdXmrMLLA7Meta?.name ?? "user-student-references",
    path: indexgdXmrMLLA7Meta?.path ?? "/user/student/references",
    meta: indexgdXmrMLLA7Meta || {},
    alias: indexgdXmrMLLA7Meta?.alias || [],
    redirect: indexgdXmrMLLA7Meta?.redirect || undefined,
    component: () => import("/app/src/pages/user/student/references/index.vue").then(m => m.default || m)
  },
  {
    name: indexdBTSfFzG9jMeta?.name ?? "user-student-theme",
    path: indexdBTSfFzG9jMeta?.path ?? "/user/student/theme",
    meta: indexdBTSfFzG9jMeta || {},
    alias: indexdBTSfFzG9jMeta?.alias || [],
    redirect: indexdBTSfFzG9jMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/student/theme/index.vue").then(m => m.default || m)
  },
  {
    name: indexsKVfReJQVcMeta?.name ?? "user-teacher-calendar_schedule",
    path: indexsKVfReJQVcMeta?.path ?? "/user/teacher/calendar_schedule",
    meta: indexsKVfReJQVcMeta || {},
    alias: indexsKVfReJQVcMeta?.alias || [],
    redirect: indexsKVfReJQVcMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/teacher/calendar_schedule/index.vue").then(m => m.default || m)
  },
  {
    name: indexr3ThPHUZuZMeta?.name ?? "user-teacher",
    path: indexr3ThPHUZuZMeta?.path ?? "/user/teacher",
    meta: indexr3ThPHUZuZMeta || {},
    alias: indexr3ThPHUZuZMeta?.alias || [],
    redirect: indexr3ThPHUZuZMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/teacher/index.vue").then(m => m.default || m)
  },
  {
    name: indexpvaEHvSxumMeta?.name ?? "user-teacher-performance",
    path: indexpvaEHvSxumMeta?.path ?? "/user/teacher/performance",
    meta: indexpvaEHvSxumMeta || {},
    alias: indexpvaEHvSxumMeta?.alias || [],
    redirect: indexpvaEHvSxumMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/teacher/performance/index.vue").then(m => m.default || m)
  },
  {
    name: indexp4KlwVwfckMeta?.name ?? "user-teacher-portfolio",
    path: indexp4KlwVwfckMeta?.path ?? "/user/teacher/portfolio",
    meta: indexp4KlwVwfckMeta || {},
    alias: indexp4KlwVwfckMeta?.alias || [],
    redirect: indexp4KlwVwfckMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/teacher/portfolio/index.vue").then(m => m.default || m)
  },
  {
    name: indexEvdQjf4XMhMeta?.name ?? "user-teacher-schedule_create",
    path: indexEvdQjf4XMhMeta?.path ?? "/user/teacher/schedule_create",
    meta: indexEvdQjf4XMhMeta || {},
    alias: indexEvdQjf4XMhMeta?.alias || [],
    redirect: indexEvdQjf4XMhMeta?.redirect || undefined,
    component: () => import("/app/src/pages/user/teacher/schedule_create/index.vue").then(m => m.default || m)
  }
]